import { useQuery } from '@tanstack/react-query'
import epsClient from 'enrollment-platform/api/eps.client'

interface CustomerListResponse {
  totalCustomers: number
  completeOnboarding: number
  onboarding: number
}

export interface OnboardingCounts {
  totalCustomers: number
  completeOnboarding: number
  onboarding: number
}

const defaultCounts: OnboardingCounts = {
  totalCustomers: 0,
  completeOnboarding: 0,
  onboarding: 0,
}

const fetchOnboardingStats = async (): Promise<OnboardingCounts> => {
  const { data } = await epsClient.get<CustomerListResponse>(
    '/api/v1/customer-onboarding/count'
  )

  return {
    totalCustomers: data.totalCustomers ?? 0,
    completeOnboarding: data.completeOnboarding ?? 0,
    onboarding: data.onboarding ?? 0,
  }
}

export default function useOnboardingStats() {
  const {
    data,
    isPending: isLoading,
    error,
  } = useQuery({
    queryKey: ['onboardingStats'],
    queryFn: fetchOnboardingStats,
  })

  return {
    counts: data ?? defaultCounts,
    isLoading,
    error,
  }
}
